import { ChevronDown, ExternalLink } from 'lucide-react';
import type { PreviousReports } from '@ballerine/common';

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components';
import type { ReactNode } from 'react';

export type PreviousReportsLinks = {
  previousMonitoringReportHref?: string | null;
  onboardingReportHref?: string | null;
};

export type { PreviousReports };

export type ToLike = string | { pathname?: string; search?: string; hash?: string };

export type LinkComponent = React.ComponentType<{
  to: ToLike;
  children: ReactNode;
  className?: string;
}>;

export type PreviousReportsButtonProps = {
  previousReportsLinks?: PreviousReportsLinks | null;
};

export const PreviousReportsButton = ({ previousReportsLinks }: PreviousReportsButtonProps) => {
  if (
    !previousReportsLinks?.previousMonitoringReportHref &&
    !previousReportsLinks?.onboardingReportHref
  ) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2">
          Previous Reports
          <ChevronDown className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {previousReportsLinks.previousMonitoringReportHref && (
          <DropdownMenuItem asChild>
            <a
              href={previousReportsLinks.previousMonitoringReportHref}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 cursor-pointer"
            >
              <ExternalLink className="h-3 w-3" />
              <span className="font-medium">Previous Monitoring Report</span>
            </a>
          </DropdownMenuItem>
        )}

        {previousReportsLinks.onboardingReportHref && (
          <>
            {previousReportsLinks.previousMonitoringReportHref && <DropdownMenuSeparator />}
            <DropdownMenuItem asChild>
              <a
                href={previousReportsLinks.onboardingReportHref}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 cursor-pointer"
              >
                <ExternalLink className="h-3 w-3" />
                <span className="font-medium">Onboarding Report</span>
              </a>
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
